import React from "react";
import { Hidden } from "@origin-digital/ods-core";
import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "./Breadcrumbs";

export const BreadcrumbBaseUri = "/help-support";
export const BreadrumbBaseName = "Help & Support";

export const BreadcrumbsController = ({ pathnameMap }): JSX.Element => {
  const location = useLocation();

  return (
    <Hidden below="md">
      <Breadcrumbs pathnameMap={pathnameMap} pathname={location.pathname} />
    </Hidden>
  );
};
